import type { SlugParamKey } from '@core/Entities/Search/QueryParams.entity';

export const getFilterValueFromSlugItem = (
  slugValue: string | undefined,
  filterKey: SlugParamKey,
) => {
  if (!slugValue) return undefined;

  if (filterKey === 'price') {
    const ltePrice = Number(slugValue.replace('under-', ''));
    return Number.isNaN(ltePrice) ? undefined : ltePrice.toString();
  }

  if (filterKey === 'doors') {
    const doors = Number(slugValue.replace('-door', ''));
    return Number.isNaN(doors) ? undefined : doors.toString();
  }

  if (filterKey === 'seats') {
    const seats = Number(slugValue.replace('-seats', ''));
    return Number.isNaN(seats) ? undefined : seats.toString();
  }

  if (filterKey === 'badge_engine_cc') {
    const size = slugValue.replace('l', '');
    return size;
  }

  if (filterKey === 'page') {
    const pageNo = Number(slugValue.replace('page-', ''));
    return Number.isNaN(pageNo) ? undefined : pageNo.toString();
  }

  return slugValue;
};
